import * as Config from '../../../config';
import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import Row from './Row';

import useGetBasic from '../../../hooks/useGetBasic';
import { setUser } from "../../../actions/index";

function ConnectedList({
  items, uri, location, style,
  api, user, isConnected,
  setUser, storeRoute
}) {
  const storeMyGenres = useGetBasic(isConnected ? `/v4/my/genres/?per_page=50` : null);

  const setHistory = useCallback((to) => () => {
    storeRoute.goTo(to);
  }, [storeRoute])

  const isSelected = (slug) => {
    const [, ,slugSelected] = location.split('/');
    return (slugSelected === slug);
  }
  const isFavorite = (id) => (user && user.genres) ? (user.genres.findIndex(x => x.id === id) >= 0) : false;
  
  const setMyGenres = (id, name) => () => {
    const index = storeMyGenres.items.findIndex(x => x.id === id);
    if (index >= 0) {
      const newGenres = [...storeMyGenres.items];
      const removed = newGenres.splice(index, 1);
      storeMyGenres.setItems([...newGenres]);
      setUser({ ...user, genres_ids: [...newGenres].map(x => x.id), genres: [...newGenres].map(x => ({id: x.id, name: x.name})) });
      api.del(`/v4/my/genres/${removed[0].id}`);
    } else {
      storeMyGenres.setItems([...storeMyGenres.items, { id, name }]);
      setUser({ ...user, genres_ids: [...storeMyGenres.items, { id }].map(x => x.id), genres: [...storeMyGenres.items, { id, name }].map(x => ({id: x.id, name: x.name})) });
      api.post(`/v4/my/genres/`, {id});
    }
  }

  const hasFavorites = (x) => (isFavorite(x.id) && isConnected);
  const electronic = (x) => ((!isFavorite(x.id) || !isConnected) && (x.category && x.category.id === 1));
  const openFormat = (x) => ((!isFavorite(x.id) || !isConnected) && (x.category && x.category.id === 2));

  useEffect(() => {
    if (location === `/genres` && items && isConnected && user) {
      const first = items.filter((item) => (user && user.genres && (user.genres.findIndex(x => x.id === item.id) >= 0))).shift();
      if (first) {
        setHistory(`${uri}/${first.slug}/featured`)();
      }
    }
  }, [location, items, uri, user, isConnected, setHistory])

  return (!items) ? null : (
    <>
      { 
       (isConnected && user && user.genres && user.genres.length > 0) ? (
        <>
          <div className={'flexRow genres-menu-title'}>
            <span className={`type-medium fz15`}>My Favorites</span>
          </div>
          <div className={`flexColumn genres-list`} style={style}>
            {  items && items.filter(hasFavorites).map( (item,i) =>
              <Row key={`genre-${item.slug}`} name={item.name}
                isSelected={isSelected(item.slug)}
                onClickTo={setHistory(`${uri}/${item.slug}/featured`)}
                isFavorite={true}
                onClickFavorite={setMyGenres(item.id, item.name)} />
            )}
          </div>
        </>
      ) : null}
      { Config.GENRES_HAS_FAV && <span className={`type-medium fz15 genres-menu-title`}>Electronic</span> }
      <div className={`flexColumn genres-list nofav`} style={style}>
        { items && items.filter(electronic).map( (item,i) =>
          <Row key={`genre-${item.slug}`} name={item.name}
            isSelected={isSelected(item.slug)}
            onClickTo={setHistory(`${uri}/${item.slug}/featured`)}
            isFavorite={false} showIconFav={Config.GENRES_HAS_FAV}
            onClickFavorite={setMyGenres(item.id, item.name)} />
        )}
      </div>
      { Config.GENRES_HAS_FAV && <span className={`type-medium fz15 genres-menu-title`}>Open Format</span> }
      <div className={`flexColumn genres-list nofav`} style={style}>
        { items && items.filter(openFormat).map( (item,i) =>
          <Row key={`genre-${item.slug}`} name={item.name}
            isSelected={isSelected(item.slug)}
            onClickTo={setHistory(`${uri}/${item.slug}/featured`)}
            isFavorite={false} showIconFav={Config.GENRES_HAS_FAV}
            onClickFavorite={setMyGenres(item.id, item.name)} />
        )}
      </div>
    </>
  )
}

ConnectedList.propTypes = {
  items: PropTypes.any,
  uri: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  style: PropTypes.object
}

const List = connect(
  state => ({
    api: state.api,
    user: state.user,
    isConnected: state.isConnected,
    storeRoute: state.storeRoute
  }),
  dispatch => ({
    setUser: user => dispatch(setUser(user))
  })
)(ConnectedList);

export default List;
